import React from 'react';
import PropTypes from 'prop-types';

import ButtonBase from '@material-ui/core/ButtonBase';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import { getString } from '../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

function AccountDetailsLayout(props) {
  const { classes, label, action, gutterTop } = props;

  return (
    <div className={classes.root}>
      <a
        className={
          gutterTop ? `${classes.back} ${classes.gutterTop}` : classes.back
        }
        onClick={(e) => {
          action();
          e.preventDefault();
        }}
        href='#'
      >
        <ChevronLeftIcon className={classes.chevronIcon} />
        {label}
      </a>
    </div>
  );
}

AccountDetailsLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string,
  action: PropTypes.func.isRequired,
  gutterTop: PropTypes.bool,
};

AccountDetailsLayout.defaultProps = {
  label: getString('app', 'BACK_LABEL'),
  gutterTop: false,
};

export default withStyles(styles)(AccountDetailsLayout);
